import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';

import { useDispatch, useSelector } from 'react-redux';
import { addCompany } from '../../features/users';

const AddCompanyForm = () => {
    const dispatch = useDispatch();
    const [company_type, setCompanyType] = useState('');
    const [type_of_tax, setTypeOftax] = useState('');
    const [name, setCompanyName] = useState('');
    const [type, setType] = useState('');
    const [eik, setCompanyEIK] = useState('');
    const [isDDS, setIsDDS] = useState(false);
    const [mol, setCompanyMOL] = useState('');
    const [country, setCompanyCountry] = useState('bg');
    const [city, setCompanyCity] = useState('');
    const [address, setCompanyAddress] = useState('');
    const [company_activity, setCompanyActivity] = useState('0');
    const [rent, setRent] = useState('1');
    const [insurance, setInsurance] = useState('1');
    const [hiredPeople, setHirdePeople] = useState(false);
    const [cash_register, setCach_register] = useState('1');
    const [bank_account, setBank_account] = useState('1');
    const [poss_account, setPoss_account] = useState('1');

    const [canEditField, setCanEditField] = useState(false);

    const [error, setError] = useState(null);
    const serverError = useSelector((state) => state.users.error);

    const userData = useSelector((state) => state.users.user);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validator()) {
            return;
        }
        dispatch(addCompany({ company_type, type_of_tax, name, type, eik, mol, country, city, address, company_activity, rent, insurance, hiredPeople, cash_register, bank_account, poss_account }));
    };

    const validator = () => {
        setError('');
        if (company_type === "") {
            setError('Моля изберете тип на фирмата');
            return false;
        } 
        if (type_of_tax === "") {
            setError('Моля изберете вид дейност');
            return false;
        }
        if (name.length < 3) {
            setError('Името на фирмата трябва да е поне 3 символа');
            return false;
        }
        if (type.length < 1) {
            setError('Mоля въведете тип на фирмата');
            return false;
        }
        if (eik.length < 9) {
            setError('Моля въведете валиден ЕИК');
            return false;
        }
        if (mol.length < 3) {
            setError('Моля въведете валиден МОЛ');
            return false;
        }
        if (city.length < 3) {
            setError('Моля въведете валиден град');
            return false;
        }
        if (address.length < 3) {
            setError('Моля въведете валиден адрес');
            return false;
        }
        if (company_activity === '0') {
            setError('Моля изберете дейност');
            return false;
        }
        return true;
    };

    useEffect(() => {
        if (company_type === 'свободна-професия') {
            setCanEditField(true);
            setCompanyName(userData.fname + ' ' + userData.mname + ' ' + userData.lname);
            setType('свободна професия');
            setCompanyMOL(userData.fname + ' ' + userData.mname + ' ' + userData.lname)
        } else {
            setCanEditField(false);
            setCompanyName('');
            setType('');
            setCompanyMOL('');
        }
    }, [company_type]);

    const renderForm = (
        <>
            <Stack spacing={3}>
                <FormControl sx={{ m: 1 }}>
                    <InputLabel id="company_type">Развивам дейността си като:</InputLabel>
                    <Select
                        id="company_type"
                        value={company_type}
                        label="Развивам дейността си като:"
                        onChange={(e) => setCompanyType(e.target.value)}
                    >
                        <MenuItem value="фирма">Фирма (ЕТ, ЕООД, ООД)</MenuItem>
                        <MenuItem value="свободна-професия">Свободна професия</MenuItem>
                    </Select>
                </FormControl>

                <FormControl sx={{ m: 1 }}>
                    <InputLabel id="type_of_tax-label">
                        {company_type === 'фирма' ? 'Правна форма' : 'Вид дейност'}
                    </InputLabel>
                    <Select
                        labelId="type_of_tax-label"
                        id="type_of_tax"
                        value={type_of_tax}
                        label={company_type === 'фирма' ? 'Правна форма' : 'Вид дейност'}
                        onChange={(e) => {
                            setTypeOftax(e.target.value);
                        }}
                    >
                        {company_type === 'фирма' && [
                            <MenuItem key="et-patent" value="ет-патентен-данък">ЕТ на патентен данък</MenuItem>,
                            <MenuItem key="corporate" value="корпоративен-данък">ЕТ, ЕООД, ООД на корпоративен данък</MenuItem>
                        ]}
                        {company_type === 'свободна-професия' && [
                            <MenuItem key="freelance" value="свободна-професия-25">Занаятчии на патентен данък, и други лица със свободна професия</MenuItem>,
                            <MenuItem key="lawyers" value="свободна-професия-40">Адвокати, избретатели, автори на произведения и артисти-изпълнители, занаятчии без патентен данък, преработватели на селскостопанска, ловна и риболовна продукция и билкари</MenuItem>,
                            <MenuItem key="farmers" value="свободна-професия-60">Земеделски стопани, производители на на непреработени продукти и тютюнопроизводители</MenuItem>
                        ]}
                        {!company_type && (
                            <MenuItem value="" disabled>Първо изберете тип на дейност</MenuItem>
                        )}
                    </Select>
                </FormControl>

                <TextField
                    name="name"
                    label="Име на фирмата"
                    type="text"
                    value={name}
                    disabled={canEditField}
                    onChange={(e) => setCompanyName(e.target.value)}
                />

                <TextField
                    name="type"
                    label="Тип на фирмата"
                    type="text"
                    placeholder="ЕООД, ЕТ, ООД"
                    value={type}
                    disabled={canEditField}
                    onChange={(e) => setType(e.target.value)}
                />


                <TextField
                    name="eik"
                    label="ЕИК"
                    type="text"
                    value={eik}
                    onChange={(e) => setCompanyEIK(e.target.value)}
                />

                <FormGroup>
                    <FormControlLabel control={<Checkbox checked={isDDS} onChange={(e) => setIsDDS(e.target.checked)} />} label="Регистрация по ДДС" />
                </FormGroup>


                {isDDS && (
                    <Typography variant="body1" sx={{ color: 'red', mt: 2 }}>
                        В момента не поддържаме регистрация по ДДС, очаквайте скоро! Може да предложим обслужване извън платформата - свържете се с нас за повече информация.
                    </Typography>
                )}

                <TextField
                    name="mol"
                    label="МОЛ"
                    type="text"
                    value={mol}
                    disabled={canEditField}
                    onChange={(e) => setCompanyMOL(e.target.value)}
                />
                <FormControl sx={{ m: 1 }}>
                    <InputLabel id="rent">Държава</InputLabel>
                    <Select
                        id="country"
                        value={country}
                        label="Държава"
                        onChange={(e) => setCompanyCountry(e.target.value)}
                    >
                        <MenuItem value="bg">България</MenuItem>
                    </Select>
                </FormControl>

                <TextField
                    name="city"
                    label="Град"
                    type="text"
                    value={city}
                    onChange={(e) => setCompanyCity(e.target.value)}
                />

                <TextField
                    name="address"
                    label="Адрес"
                    type="text"
                    value={address}
                    onChange={(e) => setCompanyAddress(e.target.value)}
                />
                <FormControl sx={{ m: 1 }}>
                    <InputLabel id="rent">Дейност</InputLabel>
                    <Select
                        id="deinost"
                        value={company_activity}
                        label="Дейност"
                        onChange={(e) => setCompanyActivity(e.target.value)}
                    >
                        <MenuItem value="0">Изберете дейност</MenuItem>
                        <MenuItem value="1">Фризьорски услуги</MenuItem>
                        <MenuItem value="2">Козметични услуги</MenuItem>
                        <MenuItem value="3">Маникюр и педикюр</MenuItem>
                        <MenuItem value="4">Масажи</MenuItem>
                        <MenuItem value="5">Автомонтьор</MenuItem>
                        <MenuItem value="6">Онлайн магазин</MenuItem>
                        <MenuItem value="7">Уеб и графичен дизайн и разработка</MenuItem>
                        <MenuItem value="8">Дигитален маркетинг и управление на социални мрежи</MenuItem>
                        <MenuItem value="9">Видео монтаж и анимация, фотография и видеозаснемане</MenuItem>
                        <MenuItem value="10">Интериорен дизайн</MenuItem>
                        <MenuItem value="11">Обучения и курсове (онлайн и на живо)</MenuItem>
                        <MenuItem value="12">Коучинг (бизнес, личностно развитие и здравословен начин на живот)</MenuItem>
                        <MenuItem value="13">Езикови курсове</MenuItem>
                        <MenuItem value="14">Психологически консултации</MenuItem>
                        <MenuItem value="15">Счетоводство и данъчни консултации</MenuItem>
                        <MenuItem value="16">Юридически услуги</MenuItem>
                        <MenuItem value="17">Виртуален асистент</MenuItem>
                        <MenuItem value="18">Преводачески услуги</MenuItem>
                        <MenuItem value="19">Строителни услуги</MenuItem>
                        <MenuItem value="20">Спедиторски услуги</MenuItem>
                        <MenuItem value="21">Таксиметрови услуги</MenuItem>
                        <MenuItem value="22">Изготвяне на бизнес планове</MenuItem>
                        <MenuItem value="23">HR услуги и подбор на персонал</MenuItem>
                        <MenuItem value="24">Разработка на мобилни приложения, UX/UI дизайн</MenuItem>
                        <MenuItem value="25">IT поддръжка и киберсигурност</MenuItem>
                        <MenuItem value="26">Автоматизация и облачни услуги</MenuItem>
                        <MenuItem value="27">Софтуерно програмиране и консултиране</MenuItem>
                        <MenuItem value="28">Фитнес треньор, Йога инструктор, Диетолог и хранителен консултант</MenuItem>
                        <MenuItem value="29">Художник, Графичен дизайнер, Татуист</MenuItem>
                        <MenuItem value="30">Почистване на домове и офиси</MenuItem>
                        <MenuItem value="31">Организиране на пространства</MenuItem>
                        <MenuItem value="32">Озеленяване и градинарство</MenuItem>
                        <MenuItem value="33">Домашни ремонти и поддръжка, ВИК, Електро и др.</MenuItem>
                        <MenuItem value="34">Дърводелец, Изработчик на мебели, Гравиране и дърворезба</MenuItem>
                        <MenuItem value="35">Обущар, Шивач, Кожар, Тъкач</MenuItem>
                        <MenuItem value="36">Гравьор, Бижутер, Златар, Часовникар</MenuItem>
                        <MenuItem value="37">Грънчар, Стъклар, Ковач, Керамик, Калайджия</MenuItem>
                        <MenuItem value="38">Реставратор, Оръжейник, Изработка на народни носии</MenuItem>
                        <MenuItem value="39">Производител на музикални инструменти</MenuItem>
                        <MenuItem value="40">Актьор, Музикант, Скулптор, Писател, Поет, Журналист, Режисьор, Сценарист</MenuItem>
                        <MenuItem value="41">Адвокат, Нотариус, Частен съдебен изпълнител</MenuItem>
                        <MenuItem value="42">Одитор, Счетоводител, Данъчен консултант</MenuItem>
                        <MenuItem value="43">Лекар, Зъболекар, Физиотерапевт</MenuItem>
                        <MenuItem value="44">Земеделски стопанин, Животновъд, Пчелар, Тютюнопроизводител</MenuItem>
                        <MenuItem value="45">Управление на Airbnb имоти</MenuItem>
                        <MenuItem value="46">Организиране на туристически маршрути и преживявания</MenuItem>
                        <MenuItem value="47">Сервизна дейност</MenuItem>
                        <MenuItem value="48">Друго (свържете се с човек от екипа на "Счетито")</MenuItem>
                    </Select>
                </FormControl>
                <FormControl sx={{ m: 1 }}>
                    <InputLabel id="rent">Ползвате ли помещение под наем за своя бизнес?</InputLabel>
                    <Select
                        id="rent"
                        value={rent}
                        label="Ползвате ли помещение под наем за своя бизнес?"
                        onChange={(e) => setRent(e.target.value)}
                    >
                        <MenuItem value="1">Не</MenuItem>
                        <MenuItem value="2">Да, наемодателят е фирма и получавам фактура за наема</MenuItem>
                        <MenuItem value="3">Да, наемодателя е частно лице и му внасям данъка на 3 месеца</MenuItem>
                        <MenuItem value="4">Да, друго (свържете се с човек от екипа на "Счетито")</MenuItem>
                    </Select>
                </FormControl>

                <FormControl sx={{ m: 1 }}>
                    <InputLabel id="insurance">Как се осигурявате или ще се осигурявате</InputLabel>
                    <Select
                        id="insurance"
                        value={insurance}
                        label="Как се осигурявате или ще се осигурявате"
                        onChange={(e) => setInsurance(e.target.value)}
                    >
                        <MenuItem value="1">Като самоосигуряващо лице</MenuItem>
                        <MenuItem value="2">С договор за управление</MenuItem>
                        <MenuItem value="3">Пенсионер съм и плащам/ще плащам само здравни осигуровки</MenuItem>
                        <MenuItem value="4">Осигурен съм на тавана и няма да плащам осигуровки</MenuItem>
                        <MenuItem value="5">Друго (свържете се с човек от екипа на "Счетито)</MenuItem>
                    </Select>
                </FormControl>

                <FormGroup>
                    <Typography variant="body1" sx={{ mt: 2 }}>
                        Имате ли наети служители?
                    </Typography>
                    <FormControlLabel
                        control={
                            <Radio
                                checked={hiredPeople === true}
                                onChange={() => setHirdePeople(true)}
                            />
                        }
                        label="Да"
                    />
                    <FormControlLabel
                        control={
                            <Radio
                                checked={hiredPeople === false}
                                onChange={() => setHirdePeople(false)}
                            />
                        }
                        label="Не"
                    />
                </FormGroup>

                {hiredPeople && (
                    <Typography variant="body1" sx={{ color: 'red', mt: 2 }}>
                        В момента нямаме функционалност за наети служители в платформата, очаквайте скоро! Може да предложим обслужване извън платформата - свържете се с нас за повече информация.
                    </Typography>
                )}

                <FormControl sx={{ m: 1 }}>
                    <InputLabel id="cash_register">Ползвате ли касов апарат за извършване на дейността си ?</InputLabel>
                    <Select
                        id="cash_register"
                        value={cash_register}
                        label="Ползвате ли касов апарат за извършване на дейността си ?"
                        onChange={(e) => setCach_register(e.target.value)}
                    >
                        <MenuItem value="1">Не</MenuItem>
                        <MenuItem value="2">Да</MenuItem>
                        <MenuItem value="3">Стартирам нов бизнес (свържете се с човек от екипа на "Счетито")</MenuItem>
                    </Select>
                </FormControl>

                {cash_register === '2' && (
                    <Typography variant="body1">
                        Трябва да разполагате с кочан за касови бележки и кочан за сторно бележки на хартия. Ако нещо не ви е ясно, свържете се с човек от екипа на "Счетито".
                    </Typography>
                )}

                <FormControl sx={{ m: 1 }}>
                    <InputLabel id="bank_account">Имате ли разкрита банкова сметка?</InputLabel>
                    <Select
                        id="bank_account"
                        value={bank_account}
                        label="Имате ли разкрита банкова сметка?"
                        onChange={(e) => setBank_account(e.target.value)}
                    >
                        <MenuItem value="1">Не</MenuItem>
                        <MenuItem value="2">Да, ползвам я само за плащане на осигуровки</MenuItem>
                        <MenuItem value="3">Да, ползвам я за банкови плащания и приемане на плащания по банков път</MenuItem>
                    </Select>
                </FormControl>

                <FormControl sx={{ m: 1 }}>
                    <InputLabel id="poss_account">Приемате ли плащания на ПОС терминал?</InputLabel>
                    <Select
                        id="poss_account"
                        value={poss_account}
                        label="Приемате ли плащания на ПОС терминал?"
                        onChange={(e) => setPoss_account(e.target.value)}
                    >
                        <MenuItem value="1">Не</MenuItem>
                        <MenuItem value="2">Да, ПОС терминала е на банката която ползвам</MenuItem>
                        <MenuItem value="3">Да, ПОС терминала е на друга банка от тази на банковата ми сметка</MenuItem>
                    </Select>
                </FormControl>

                <Typography variant="body1" sx={{ mt: 2 }}>
                    Рекламата във Фейсбук и други социални мрежи, както и закупуване на стоки от ЕС, изисква регистрация по ДДС. Ако възнамерявате да рекламирате в социалните мрежи или да закупувате стоки и консумативи от ЕС, моля преди да го направите се свържете с екипа на "Счетито" за да ви консултираме как да го направите.
                </Typography>

            </Stack>
            {error && (
                <Typography variant="body1" sx={{ color: 'red', mt: 2 }}>
                    {error}
                </Typography>
            )}
            {serverError && (
                <Typography variant="body1" sx={{ color: 'red', mt: 2 }}>
                    {serverError}
                </Typography>
            )}
            <LoadingButton
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                color="inherit"
                onClick={handleSubmit}
                disabled={isDDS}
                sx={{ mt: 3 }}
            >
                Добави фирма
            </LoadingButton>
        </>
    );


    return (
        <Stack alignItems="center" justifyContent="center" sx={{ height: 1 }}>
            <Card
                sx={{
                    p: 5,
                    width: 1,
                }}
            >
                <Typography variant="h4">За да продължите, моля добавете вашата фирма</Typography>
                <Box sx={{ mt: 3 }}>{renderForm}</Box>
            </Card>
        </Stack>
    );
};

export default AddCompanyForm;